export default __webpack_public_path__ + "static/media/Shoulder Strap of the Great Impi.c6121e75.jpg";